<script setup lang="ts">
import type { Event } from "#shared/types/events";

const props = defineProps<{ event: Event }>();

const isFullyBooked = computed(() => {
  const maxDate = new Date(
    Math.max(...props.event.dates.map((it) => it.getTime())),
  );

  return isFuture(maxDate) && props.event.signUpForm && props.event.fullBooked;
});

const maxWidth = "57rem";
</script>

<template>
  <section
    data-hero
    class="mx-auto mb-12 h-min rounded-2xl bg-(--event-background) pb-8 text-lg text-green-50 xs:my-12"
    :class="event.eventType"
  >
    <div class="relative">
      <CardsEventCover
        :event="event"
        placeholder
        :sizes="maxWidth"
        class="sm:rounded-none"
      />
      <UiGraphicsDateBox
        class="absolute bottom-8 left-8 sm:left-16"
        :dates="event.dates"
        aria-hidden="true"
      />
    </div>
    <div class="flex flex-col gap-4 px-8 py-6 xs:px-16">
      <UiCommonsTag :event="event" size="medium" />
      <CardsEventTitle
        tag="h1"
        :event="event"
        data-title
        class="text-3xl tracking-widest"
      />
      <CardsEventDates :event="event" weekday="long" />
      <CardsEventTime :event="event" />
      <CardsEventLocation :event="event" hide-webinar-link />
      <CardsEventVideoLink :event="event" />
      <CardsEventAddress :event="event" />
      <CardsEventExternalSite :event="event" />
      <p v-if="isFullyBooked" class="mt-2">
        Arrangementet er dessverre fullbooket
      </p>
    </div>
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

[data-hero] {
  max-width: v-bind(maxWidth);
}

[data-title] {
  /* FIXME: These should be added directly on the element, but we can't until we sort out the screen order in tailwind.config.ts */
  @media screen and (min-width: theme("screens.xs")) {
    @apply text-5xl;
  }

  @media screen and (min-width: theme("screens.sm")) {
    @apply text-6xl;
  }
}
</style>
